module.exports = __webpack_public_path__ + "img/bg-mision-2-15.ca704dde.jpg";